import { call, put } from 'redux-saga/effects'
import BusinessActions from '../actions/business-actions'
import * as api from "../../Service/api";

export function* getBusiness(action) {
    const { businessId } = action
    // make the call to the api
    const response = yield call(api.getBusiness, businessId)

    // success?
    if (response.ok) {
        yield put(BusinessActions.businessSuccess(response.data))
    } else {
        yield put(BusinessActions.businessFailure(response.data))
    }
}

export function* getBusinesses(action) {
    const { options } = action
    // make the call to the api
    const apiCall = call(api.getBusinesses, options)
    const response = yield call(apiCall)

    // success?
    if (response.ok) {
        yield put(BusinessActions.businessAllSuccess(response.data))
    } else {
        yield put(BusinessActions.businessAllFailure(response.data))
    }
}
export function* getBusinessSummary(action) {
    const { businessId } = action
    //make the call to the api
    const response = yield call(api.getBusinessSummary, businessId)
    // success?
    if (response.ok) {
        yield put(BusinessActions.businessSummarySuccess(response.data))
    } else {
        yield put(BusinessActions.businessSummaryFailure(response.data))
    }
}

export function* createBusiness(action) {
    const { business } = action
    // make the call to the api
    // const idIsNotNull = !!business.id
    // const apiCall = call( api.createBusiness, business)
    const response = yield call(api.createBusiness, business)

    // success?
    if (response.ok) {
        yield put(BusinessActions.businessCreateSuccess(response.data))
    } else {
        yield put(BusinessActions.businessCreateFailure(response.data))
    }
}
export function* updateBusiness(action) {
    const { businessId, business } = action
    // make the call to the api
    // const idIsNotNull = !!business.id
    // const apiCall = call(api.updateBusiness, business)
    const response = yield call(api.updateBusiness, businessId, business)

    // success?
    if (response.ok) {
        yield put(BusinessActions.businessUpdateSuccess(response.data))
    } else {
        yield put(BusinessActions.businessUpdateFailure(response.data))
    }
}

export function* updatePspBill(action) {
    const { businessId } = action
    const response = yield call(api.updatePspFees, businessId)
    // success?
    if (response.ok) {
        yield put(BusinessActions.updatePspBillSuccess(response.ok))
    } else {
        yield put(BusinessActions.updatePspBillFailure(response.ok))
    }
}

export function* toggleReqsEnabled(action) {
    const { businessId } = action
    const response = yield call(api.toggleReqsEnabled, businessId)
    if (response.ok) {
        yield put(BusinessActions.toggleReqsEnabledSuccess(response.data))
    } else {
        yield put(BusinessActions.toggleReqsEnabledFailure(response.data))
    }
}

export function* toggleAllowDuplicatePhone(action) {
    const { businessId } = action
    const response = yield call(api.toggleAllowDuplicatePhone, businessId)
    if (response.ok) {
        yield put(BusinessActions.toggleAllowDuplicatePhoneSuccess(response.data))
    } else {
        yield put(BusinessActions.toggleAllowDuplicatePhoneFailure(response.data))
    }
}

export function* createSignupReqs(action) {
    const { businessId, tagGroupIds } = action
    const response = yield call(api.createSignupReqs, businessId, tagGroupIds)
    if (response.ok) {
        yield put(BusinessActions.createSignupReqsSuccess(response.data))
    } else {
        yield put(BusinessActions.createSignupReqsFailure(response.data))
    }
}

export function* fetchSignupReqs(action) {
    const { businessId } = action
    const response = yield call(api.getSignupReqs, businessId)
    if (response.ok) {
        yield put(BusinessActions.fetchSignupReqsSuccess(response.data))
    } else {
        yield put(BusinessActions.fetchSignupReqsFailure(response.data))
    }
}

export function* deleteSignupReq(action) {
    const { businessId, signupReqId } = action
    const response = yield call(api.deleteSignupReq, businessId, signupReqId)
    if (response.ok) {
        yield put(BusinessActions.deleteSignupReqSuccess(response.data))
    } else {
        yield put(BusinessActions.deleteSignupReqFailure(response.data))
    }
}

export function* fetchSignupReqExclusions(action) {
    const { businessId } = action
    const response = yield call(api.getSignupReqExclusions, businessId)
    if (response.ok) {
        yield put(BusinessActions.fetchSignupReqExclusionsSuccess(response.data))
    } else {
        yield put(BusinessActions.fetchSignupReqExclusionsFailure(response.data))
    }
}

export function* createSignupReqExclusions(action) {
    const { businessId, planGroupIds } = action
    const response = yield call(api.createSignupReqExclusions, businessId, planGroupIds)
    if (response.ok) {
        yield put(BusinessActions.createSignupReqExclusionsSuccess(response.data))
    } else {
        yield put(BusinessActions.createSignupReqExclusionsFailure(response.data))
    }
}

export function* deleteSignupReqExclusion(action) {
    const { businessId, exclusionId } = action
    const response = yield call(api.deleteSignupReqExclusion, businessId, exclusionId)
    if (response.ok) {
        yield put(BusinessActions.deleteSignupReqExclusionSuccess(response.data))
    } else {
        yield put(BusinessActions.deleteSignupReqExclusionFailure(response.data))
    }
}

export function* deleteBusiness(action) {
    const { businessId } = action
    // make the call to the api
    const apiCall = call(api.deleteBusiness, businessId)
    const response = yield call(apiCall)

    // success?
    if (response.ok) {
        yield put(BusinessActions.businessDeleteSuccess())
    } else {
        yield put(BusinessActions.businessDeleteFailure(response.data))
    }
}

export function* closeNotification(action) {
    const { businessId } = action
    // make the call to the api
    const response = yield call(api.closeNotification, businessId)

    // success?
    if (response.ok) {
        yield put(BusinessActions.businessCloseNotificationSuccess(response.data))
    } else {
        yield put(BusinessActions.businessCloseNotificationFailure(response.data))
    }
}

export function* getQrCode(action) {
    const { businessId } = action
    // make the call to the api
    const response = yield call(api.getBusinessQr, businessId)

    //success?
    if (response.ok) {
        yield put(BusinessActions.businessQrCodeSuccess(response.data))
    } else {
        yield put(BusinessActions.businessQrCodeFailure(response.data))
    }
}
export function* getIndustries(action) {
    const { industry } = action
    //make the call to the api
    const response = yield call(api.getIndustries, industry)

    //success?
    if (response.ok) {
        yield put(BusinessActions.businessIndustriesSuccess(response.data))
    } else {
        yield put(BusinessActions.businessIndustriesFailure(response.data))
    }
}